import PastMonthsSummaryWidgetView from './PastMonthsSummaryWidgetView.vue';

export const type = 'pastMonthsSummary';
export const view = PastMonthsSummaryWidgetView;

export function builder() {
  return {
    type,
    top: 0,
    rotate: 0,
    zIndex: 1,
    width: 430,
    marginTop: 20,
    marginBottom: 0,
    borderRadius: 25,
    textColor: '#0C3467',
    totalColor: '#13C636',
    fontSize: 18,
    fontFamily: 'SimplerPro',
    boxShadow: '0px 4px 21px rgba(149.13, 152.94, 149.88, 0.56)',
    variableName: '',
    variableData: [],
  };
}
